import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import Icon from '../../../Icon'
import './styles.scss'
import AttributeMultiSelectPill from './attribute-multi-select-pill'
import activityTrackingService from '../../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../../constants'
import { getTrackingFactLabel } from '../../helper'
import { environment } from '../../../../../environment'

class AttributeMultiSelectPills extends PureComponent {
  state = {
    options: []
  }

  componentDidMount () {
    this.buildOptions()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.blueprint !== this.props.blueprint) {
      this.buildOptions()
    }
  }

  buildOptions () {
    const options = this.props.blueprint.options.map((option) => {
      let label = option.label
      if (!option.hasOwnProperty('label')) {
        const attribute = this.props.factsheetBlueprint.factTree.attributes[option.id]
        label = attribute.label
      }
      return {
        label: label,
        value: option.id
      }
    })
    this.setState({ options })
    return options
  }

  getSelectedOptionsMap () {
    const selectedOptions = {}
    if (this.props.data.hasOwnProperty('attributes')) {
      for (let option of this.state.options) {
        if (this.props.data.attributes.hasOwnProperty(option.value)) {
          selectedOptions[option.value] = option
        }
      }
    }
    return selectedOptions
  }

  onPillClick (option, selected) {
    activityTrackingService.trackEvent(trackingEvent.editValue, {
      name: getTrackingFactLabel(this.props.parentBlueprint, this.props.factsheetBlueprint)
    })
    if (selected) {
      this.props.putAttribute(
        this.props.parentBlueprint.id,
        this.props.factInstanceKey,
        option.value,
        { attributeDefId: option.value }
      )
      return
    }
    this.props.deleteAttribute(
      this.props.parentBlueprint.id,
      this.props.factInstanceKey,
      option.value
    )
  }

  render () {
    const label = this.props.blueprint.label
    const definition = this.props.blueprint.definition
    const showActions = !!definition
    const selectedOptionsMap = this.getSelectedOptionsMap()

    if (this.props.collapsed) {
      if (Object.keys(selectedOptionsMap).length === 0) {
        return null
      }
      let foundOptions = 0
      const collapsedContent = []
      for (let index in this.state.options) {
        if (selectedOptionsMap.hasOwnProperty(this.state.options[index].value)) {
          foundOptions++
          const keyUsed = this.state.options[index].value
          if (environment.IS_DEV && window.__LOG_FS_KEYS) {
            if (!keyUsed) {
              console.warn('Factsheet key missing in AttributeMultiSelectPills (collapsed option)', {
                option: this.state.options[index]
              })
            }
            console.debug('Factsheet key used (AttributeMultiSelectPills collapsed):', keyUsed)
          }
          collapsedContent.push(
            <span key={keyUsed}>{foundOptions > 1 && ', '}{this.state.options[index].label}</span>)
        }
      }
      return <div className={'attribute-multi-select-pills-collapsed'}>
        {label}: {collapsedContent}
      </div>
    }

    return (
      <div className={'attribute-multi-select-pills'}>
        <div className={'attribute-multi-select-pills-header'}>
          <label>{label}</label>
          {
            showActions && (
              <div className={'attribute-multi-select-actions'}>
                {definition && <Icon type={'how'} tooltip={definition}/>}
              </div>
            )
          }
        </div>
        <div className={'attribute-multi-select-pills-content'}>
          {this.state.options.map(option => {
            const isSelected = selectedOptionsMap.hasOwnProperty(option.value)
            const attribute = this.props.factsheetBlueprint.factTree.attributes[option.value]
            return <AttributeMultiSelectPill
              key={option.value}
              isSelected={isSelected}
              onClick={() => {this.onPillClick(option, !isSelected)}}
              label={option.label} definition={attribute.definition}/>
          })}
        </div>
      </div>
    )
  }
}

AttributeMultiSelectPills.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number.isRequired,
  putAttribute: PropTypes.func.isRequired,
  deleteAttribute: PropTypes.func.isRequired,
  putValidationStatus: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired, // factInstance
}
export default AttributeMultiSelectPills
